module.exports = __webpack_public_path__ + "static/media/bestquote_logo_white.5a93f9b4.svg";